import { Component, Inject, OnInit, NgZone } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import {
  AppNotification,
  NotificationService,
} from 'src/app/shared/services/notification.service';

@Component({
  selector: 'app-notification-list-dialog',
  templateUrl: './notification-list-dialog.component.html',
  styleUrls: ['./notification-list-dialog.component.scss'],
})
export class NotificationListDialogComponent implements OnInit {
  notifications: AppNotification[] = [];
  userRole: 'customer' | 'business' = 'customer';

  constructor(
    public dialogRef: MatDialogRef<NotificationListDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      notifications: AppNotification[];
      userRole: 'customer' | 'business';
      userId: string;
    },
    private router: Router,
    private notificationService: NotificationService,
    private ngZone: NgZone,
  ) { }

  ngOnInit(): void {
    this.userRole = this.data.userRole || 'customer';

    // Filter for last 7 days
    const oneWeekAgo = new Date();
    oneWeekAgo.setDate(oneWeekAgo.getDate() - 7);

    this.notifications = this.data.notifications.filter((n) => {
      const date = n.createdAt?.toDate
        ? n.createdAt.toDate()
        : new Date(n.createdAt);
      return date >= oneWeekAgo;
    });
  }

  close() {
    this.dialogRef.close();
  }

  handleNotificationClick(note: AppNotification) {
    // console.log('Dialog: Notification clicked', note);
    // alert('Dialog Clicked: ' + (this.userRole || 'no role'));
    this.navigateToTarget(note);
    this.close();
  }

  navigateToTarget(note: AppNotification) {
    this.ngZone.run(() => {
      const notifLink: string = note.link || '';

      // If the notification has a '/booking-orders' link, always go to customer order flow.
      // This handles the case where a vendor booked as a customer and receives customer notifications.
      if (notifLink.startsWith('/booking-orders')) {
        if (note.bookingId) {
          this.router.navigate(['/booking-orders', note.bookingId]);
        } else {
          this.router.navigate(['/booking-orders']);
        }
        return;
      }

      // Business / Vendor Logic (vendor receiving a booking request)
      if (this.userRole === 'business') {
        if (note.bookingId) {
          this.router.navigate([
            '/business/booking/booking-details',
            note.bookingId,
          ]);
        } else {
          // Fallback if no ID is present
          this.router.navigate(['/business/booking']);
        }
        return;
      }

      // Default Customer Logic
      if (note.bookingId) {
        this.router.navigate(['/booking-orders', note.bookingId]);
      } else {
        this.router.navigate(['/booking-orders']);
      }
    });
  }

  clearAll() {
    if (this.data.userId) {
      if (confirm('Are you sure you want to clear all notifications?')) {
        this.notificationService.clearAllNotifications(this.data.userId);
        this.close();
      }
    }
  }
}
